import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Alert from "UI/Alert";

import * as NotificationActions from "../../data/notifications/NotificationActions";

class AlertsWrapper extends React.Component
{
    static propTypes = {
        alerts: PropTypes.array.isRequired,
        removeNotification: PropTypes.func.isRequired,
    };

    close = id => {
        this.props.removeNotification(id);
    };

    render()
    {
        if (this.props.alerts.length < 1) {
            return null;
        }

        return this.props.alerts.map(notification => {
            return <Alert
                key={notification.id}
                {...notification}
                close={() => this.close(notification.id)}
            />;
        });
    }
}

const mapStateToProps = (state, ownProps) => ({
    alerts: state.notifications
});

const mapDispatchToProps = {
    removeNotification: NotificationActions.removeNotification,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AlertsWrapper);
